var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollable-modal",attrs:{"id":"NyugtaModal"}},[_c('modal',{attrs:{"height":"auto","name":"NyugtaModal","width":"600px"},on:{"before-open":_vm.beforeModalOpen}},[_c('div',{staticClass:"modal-content"},[_c('embed',{attrs:{"src":_vm.url,"width":"580px","height":"700px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }